import React, { useEffect, useState } from 'react';
import './Study.css';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import Spinner from '../Spinner/Spinner';
import { withRouter } from "react-router";
import { post } from '../../app/shared/http';
import { withAuth } from "../../app/util/HOC";
import StudyCenterHeader from './StudyCenterHeader';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import { handleException } from "../../app/util/util";
import loaderColors1 from '../Spinner/loaderColors1.gif';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
export function StudyWatchVideo(props) {
    const userVO = JSON.parse(localStorage.getItem('userVO'));
    const [bookVO, setBookVO] = useState(JSON.parse(localStorage.getItem('bookVO')));
    const [loName, setLoName] = useState("");
    const [isLoading, setisLoading] = useState(false);
    const [currentQuestion, setCurrentQuestion] = useState(null);
    const [totalQuestionCount, setTotalQuestionCount] = useState(0);
    const [questionBankVOList, setQuestionBankVOList] = useState(null);
    useEffect(() => {
        async function fetchQuestions() {
            let reqData = {
                "bookVO": { "bookISBN": props.match.params.isbn },
                "questionVO": {
                    "explainertype": "1",
                    "questionType": "explanatory",
                    "bookISBN": props.match.params.isbn,
                    "chapterId": props.match.params.chapterid,
                    "learningObjectId": props.match.params.loid
                }
            }
            setisLoading(true);
            post("/assessmentRetrievalService/getQuestionForStudyCenterLearnRv", reqData, 'ENV')
                .then(response => response.json())
                .then(data => {
                    if (data.status === "false" && data.wkErrorCode) {
                        handleException(data);
                    }
                    if (data.status === "true") {
                        let loName = data.learningObjName;
                        if (data.assessmentVO && data.assessmentVO.questionBankVOList) {
                            data.bookVO.chapterId = props.match.params.chapterid;
                            let flag = 0;
                            data.assessmentVO.questionBankVOList = Array.isArray(data.assessmentVO.questionBankVOList) ? data.assessmentVO.questionBankVOList : [data.assessmentVO.questionBankVOList]
                            for (let i = 0; i < data.assessmentVO.questionBankVOList.length; i++) {
                                if (data.assessmentVO.questionBankVOList[i].questionResponseVO.status === "not attempted") {
                                    updateCurrentQuestionBtn(i + 1);
                                    flag = 1;
                                    setTotalQuestionCount(data.assessmentVO.countOfTotalQuestion);
                                    setQuestionBankVOList(data.assessmentVO.questionBankVOList);
                                    setCurrentQuestion(data.assessmentVO.questionBankVOList[i]);
                                    setBookVO(data.bookVO);
                                    setLoName(loName);
                                    setisLoading(false);
                                    break;
                                }
                            }
                            if (flag === 0) {
                                updateCurrentQuestionBtn(1);
                                setTotalQuestionCount(data.assessmentVO.countOfTotalQuestion);
                                setQuestionBankVOList(data.assessmentVO.questionBankVOList);
                                setCurrentQuestion(data.assessmentVO.questionBankVOList[0]);
                                setBookVO(data.bookVO);
                                setLoName(loName);
                                setisLoading(false);
                            }
                        } else
                            setLoName(loName);
                        setisLoading(false);
                    }
                }).catch(error => {
                    console.error("There has been a problem with your fetch operation:", error);
                    setisLoading(false);
                });
        }
        fetchQuestions();
    }, []);
    const updateCurrentQuestionBtn = (questionNumber, btnName) => {
        document.querySelectorAll('.questionNumberBtn').forEach(x => {
            x.classList.remove("active-question-btn");
        });
        if (document.getElementById("btnQuestion_" + questionNumber - 1)) {
            document.getElementById("btnQuestion_" + questionNumber - 1).classList.remove("active-question-btn");
            document.getElementById("btnQuestion_" + questionNumber - 1).style.border = "inherit";
        }
        if (document.getElementById("btnQuestion_" + questionNumber + 1)) {
            document.getElementById("btnQuestion_" + questionNumber + 1).classList.remove("active-question-btn");
            document.getElementById("btnQuestion_" + questionNumber + 1).style.border = "inherit";
        }
        if (btnName === "Skip" || btnName === "Next") {
            if (document.getElementById("btnQuestion_" + questionNumber))
                document.getElementById("btnQuestion_" + questionNumber).classList.add("active-question-btn")
            document.querySelectorAll('.questionNumberBtn').forEach(x => x.style.border = "inherit")
        }
    }
    const getQuestion = (e) => {
        setCurrentQuestion(questionBankVOList[parseInt(e.target.getAttribute("arrayIndex"))]);
        updateCurrentQuestionBtn(parseInt(e.target.getAttribute("arrayIndex")) + 1, e.currentTarget.innerText);
    }
    const navigateToStudyDashboard = (e) => {
        props.history.push(`/study/${props.match.params.isbn}/${props.match.params.chapterid}`);
    }
    const questionNumbers = (totalQuestionCount, questionBankVOList) => {
        let btnArray = []
        if (questionBankVOList !== undefined) {
            for (let i = 0, j = 0; i < questionBankVOList.length; i++, j++) {
                if (questionBankVOList[i].questionResponseVO.status === "incorrect") {
                    btnArray.push(<span arrayIndex={j} onClick={(e) => getQuestion(e)}>
                        <button arrayIndex={j} style={{ color: questionBankVOList[i].currentQuestionFlag == 1 ? '#000000' : undefined, border: undefined }} id={"btnQuestion_" + questionBankVOList[i].questionNumber} className="questionNumberBtn numberBox redBgColor">{i + 1}</button> &nbsp;&nbsp; </span>)
                }
                else if (questionBankVOList[i].questionResponseVO.status === "correct") {
                    btnArray.push(<span arrayIndex={j} onClick={(e) => getQuestion(e)}>
                        <button arrayIndex={j} style={{ color: questionBankVOList[i].currentQuestionFlag == 1 ? '#000000' : undefined, border: undefined }} id={"btnQuestion_" + questionBankVOList[i].questionNumber} className="questionNumberBtn numberBox greenBgColor">{i + 1}</button> &nbsp;&nbsp; </span>)
                }
                else if (questionBankVOList[i].questionResponseVO.status === "partial") {
                    btnArray.push(<span arrayIndex={j} onClick={(e) => getQuestion(e)}>
                        <button arrayIndex={j} style={{ color: questionBankVOList[i].currentQuestionFlag == 1 ? '#000000' : undefined, border: undefined }} id={"btnQuestion_" + questionBankVOList[i].questionNumber} className="questionNumberBtn numberBox blueBgColor">{i + 1}</button> &nbsp;&nbsp; </span>)
                } else {
                    btnArray.push(<span arrayIndex={j} onClick={(e) => getQuestion(e)}>
                        <button arrayIndex={j} style={{ color: questionBankVOList[i].currentQuestionFlag == 1 ? '#007AC3' : undefined, border: undefined }} id={"btnQuestion_" + questionBankVOList[i].questionNumber} className="questionNumberBtn numberBox">{i + 1}</button> &nbsp;&nbsp; </span>)
                }
            }
        }
        return btnArray;
    }
    const handleBackToStudyCenter = (e) => {
        if (e.key === "Enter") {
            navigateToStudyDashboard(e);
        }
    }
    return (
        <React.Fragment>
            <Header userVO={userVO} bookVO={bookVO} pageName="study" ></Header>
            <StudyCenterHeader userVO={userVO} />
            <div className="col-lg-12">
                <div className="row greyDiv">
                    <div className="col-lg-8 headingDiv">
                        <span className="insightProperty">{loName}</span><br />
                        <span className="insightHeading">Watch a Video</span><br />
                        <span className="studyLink cusorPointer" onClick={navigateToStudyDashboard} tabIndex="0" onKeyDown={(e) => handleBackToStudyCenter(e)}> Back to Study Center </span>
                    </div>
                    <div className="col-lg-4" style={{ margin: 'auto' }}>
                        <ButtonToolbar aria-label="Toolbar with button groups" style={{ justifyContent: 'center' }}>
                            <ButtonGroup className="mr-2" aria-label="First group">
                                {questionBankVOList !== null ?
                                    questionNumbers(totalQuestionCount, questionBankVOList) : null}
                            </ButtonGroup>
                        </ButtonToolbar>
                    </div>
                </div>
                <div className="row">
                    <Spinner
                        loading={isLoading}
                        imageSrc={loaderColors1}
                        overlayBackground="rgba(0,0,0,0.7)"
                        label="Loading the video"
                    />
                    <div className="col-lg-10 mx-auto">
                        <div className="studyDiv">
                            {
                                currentQuestion !== null ?
                                    <div className="questionSection">
                                        <div className="video-div">
                                            <div className="video-div1">
                                                <iFrame src={
                                                    currentQuestion.questionVO.explainerLinkVOList.provider === "VM" ?
                                                        currentQuestion.questionVO.explainerLinkVOList.expdetail :
                                                        "https://players.brightcove.net/20782352001/Vgqo3XXiY_default/index.html?videoId=" + currentQuestion.questionVO.explainerLinkVOList.expdetail
                                                } allowFullScreen allow="encrypted-media" className="iframe-video" />
                                            </div>
                                        </div>
                                    </div> : null
                            }
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </React.Fragment>
    )
}
export default withAuth(withRouter(StudyWatchVideo));